import { render, staticRenderFns } from "./HeadquarterTemplateData.vue?vue&type=template&id=7cf6f4d3&"
import script from "./HeadquarterTemplateData.vue?vue&type=script&lang=ts&"
export * from "./HeadquarterTemplateData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports